<template>
  <fieldset class="border-0 mb-4 p-0 border-b border-balternative-color px-6">
    <div class="grid grid-cols-2 mb-2">
      <div class="text-xl text-pdsPrimaryColor">Favorieten</div>
      <div class="text-end">
        <PencilSquareIcon
          v-if="favourites.length > 0"
          @click.prevent="showOverlay"
          class="h-5 w-5 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
        <ChevronDownIcon
          @click.prevent="toggleDetails()"
          v-if="!collapsed"
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
        <ChevronUpIcon
          @click.prevent="toggleDetails()"
          v-else
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
      </div>
    </div>
    <div v-if="value.length > 0 && isCustomerFlow" class="mb-4">
      <button
        @click.prevent="addSelectedFavoriteAllProducts()"
        class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full hover:bg-primary-default/50 items-center mb-2 mr-2"
      >
        <span class="">Producten bestellen</span>
      </button>
    </div>
    <div v-if="!collapsed" class="mb-4">
      <v-checkbox-group
        class="mb-2"
        v-for="(favourite, index) in favourites"
        :key="index"
        :label="favourite.name"
        :inputid="'favourite.BundleId' + index"
        :initvalue="selected.indexOf(favourite) > -1"
        :overwrite-value="selected.indexOf(favourite) > -1"
        @update="change(favourite, $event)"
      />
    </div>
  </fieldset>
</template>

<script>
import router from '@/router';
import VCheckboxGroup from './CheckboxGroup';
import { ChevronDownIcon, ChevronUpIcon, PencilSquareIcon } from '@heroicons/vue/20/solid';
import { useResponsiveCollapse } from '@/composables/useResponsiveCollapse';
import { shoppingCart$, addBundlesToShoppingCart } from '@/services';
import { ref } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'VFavouriten',
  components: {
    VCheckboxGroup,
    ChevronDownIcon,
    ChevronUpIcon,
    PencilSquareIcon
  },
  props: {
    favourites: Array,
    value: {
      default: () => [],
      type: Array
    }
  },
  setup(props, { emit }) {
    const { collapsed } = useResponsiveCollapse();
    const selected = ref([]);
    const store = useStore();
    const shoppingCart = ref(null);

    const setOverlayActive = (value) => store.commit('catalog/setOverlayActive', value);

    shoppingCart$.subscribe((value) => {
      shoppingCart.value = value;
    });

    const toggleDetails = () => {
      collapsed.value = !collapsed.value;
    };

    return {
      selected,
      collapsed,
      toggleDetails,
      setOverlayActive,
      shoppingCart
    };
  },
  computed: {
    isCustomerFlow() {
      return router.currentRoute.value.meta.flow === 'customer';
    }
  },
  methods: {
    showOverlay() {
      this.setOverlayActive(true);
    },
    change(favourite, active) {
      if (active) {
        this.selected.push(favourite);
      } else {
        const index = this.selected.findIndex((item) => item.bundleId === favourite.bundleId);
        if (index !== -1) {
          this.selected.splice(index, 1);
        }
      }
      this.$emit('update:modelValue', this.selected);
    },
    /**
     * @function addSelectedFavoriteAllProducts - Function to add all products from the selected favourite to the cart
     */
    addSelectedFavoriteAllProducts() {
      const bundleIds = this.value.map((v) => v.bundleId);
      addBundlesToShoppingCart(this.shoppingCart, bundleIds);
      this.showAlert();
    },
    // Function to show an alert message
    showAlert() {
      this.$emitter.emit('alert', {
        message: 'Alle producten zijn toegevoegd aan de bestellijst.'
      });
    }
  }
};
</script>
